/**
 * Mapeo de categorías del website a los valores de businessCategory
 * que se envían en la URL de suscripción
 */

export const categoryToBusinessCategoryMapping: Record<string, string> = {
  'almacen-kiosco': 'almacen-kiosco',
  'carniceria-polleria': 'carniceria',
  'comida-rapida': 'comida-rapida',
  'dietetica-tiendas-saludables': 'dietetica',
  farmacia: 'farmacia',
  ferreteria: 'ferreteria',
  floristeria: 'floristeria',
  heladeria: 'heladeria',
  'decoracion-y-hogar': 'hogar-deco-general',
  indumentaria: 'indumentaria-general',
  jugueteria: 'jugueteria',
  'libreria-papeleria': 'libreria-papeleria',
  'panaderia-pasteleria': 'panaderia',
  'pet-shop-mascotas': 'pet-shop',
  repuestos: 'repuestos',
  'restaurante-cafeteria': 'restaurante',
  rotiseria: 'rotiseria',
  'salud-y-belleza': 'salud-belleza-general',
  'tecnologia-repuestos': 'tecnologia-general',
  verduleria: 'verduleria',
  'vinoteca-bebidas': 'vinoteca-bebidas',
  otros: 'otros',
};

/**
 * Obtiene el valor de businessCategory para una categoría dada
 * @param categoryId - ID de la categoría del website
 * @returns El valor correspondiente de businessCategory o undefined si no existe
 */
export const getBusinessCategoryForCategory = (categoryId: string): string | undefined => {
  return categoryToBusinessCategoryMapping[categoryId];
};

/**
 * Obtiene el slug de categoría a partir del nombre de categoría
 * @param categoryName - Nombre de la categoría
 * @returns El slug correspondiente o 'general' si no existe
 */
export const getCategorySlugFromName = (categoryName: string): string => {
  const entry = Object.entries(categoryToBusinessCategoryMapping).find(
    ([, value]) => value === categoryName
  );
  return entry ? entry[0] : 'otros';
};